import { render, staticRenderFns } from "./ed-collaborative-text-toolbar.vue?vue&type=template&id=6c58456c&"
import script from "./ed-collaborative-text-toolbar.ts?vue&type=script&lang=ts&"
export * from "./ed-collaborative-text-toolbar.ts?vue&type=script&lang=ts&"
import style0 from "@/assets/styles/quill.snow.css?vue&type=style&index=0&lang=css&"
import style1 from "./ed-collaborative-text-toolbar.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports